import { useState, useEffect } from 'react';
import { checkFeatureFlags } from 'api';

let cachedFlags: any = null;
let lastFetchTime: number | null = null;
let fetchPromise: Promise<any> | null = null;

const CACHE_DURATION = 5 * 60 * 1000; // 5 mins

export const fetchFeatureFlags = async (): Promise<any> => {
  const now = Date.now();

  if (cachedFlags !== null && lastFetchTime !== null) {
    const timeSinceLastFetch = now - lastFetchTime;
    if (timeSinceLastFetch < CACHE_DURATION) {
      return cachedFlags;
    }
  }

  if (fetchPromise) {
    return await fetchPromise;
  }

  fetchPromise = checkFeatureFlags()
    .then(response => {
      const newFlags = response.flags;
      cachedFlags = newFlags;
      lastFetchTime = Date.now();
      fetchPromise = null;
      return newFlags;
    })
    .catch(err => {
      fetchPromise = null;
      throw err;
    });

  return await fetchPromise;
};

export const clearFeatureFlagsCache = (): void => {
  cachedFlags = null;
  lastFetchTime = null;
  fetchPromise = null;
};

export const useFeatureFlags = (notCall = false) => {
  const [flags, setFlags] = useState<any>(null);

  useEffect(() => {
    const loadFlags = async () => {
      try {
        const fetchedFlags = await fetchFeatureFlags();
        setFlags(fetchedFlags);
      } catch (err) {
        setFlags(null);
        if (cachedFlags !== null) {
          setFlags(cachedFlags);
        }
      }
    };
    if (!notCall) {
      loadFlags();
    }
  }, [notCall]);

  return { flags };
};
